<template>
  <div id="account_secuity">
    <change-password ref="changePassComponent" />
    <otp-modal
      name="otp_modal"
      :submit="updateModeWhitelist"
      :params="getParamsUpdateModeWhitelist()"
      :is-disable-button="isDisableButton"
      :contact_email="siteSetting.contact_email"
    />
    <cancel-google-auth-modal
      @CancelGoogleAuthModal:CLOSE="hideCancelGoogleAuthModal"
    ></cancel-google-auth-modal>
    <enable-google-authentication
      :user="user"
      @EnableGoogleAuthentication:CLOSE="hideEnableGoogleAuthenticaion"
    ></enable-google-authentication>
    <VerifyOTP
      v-if="enableOtp"
      :visible="showDisableModal"
      @close="showDisableModal = false"
      @complete="handleCompleteDisable"
      title="Disable Google Authenticator"
    />
    <VerifyOTP
      v-else
      :visible="showOtp"
      @close="showOtp = false"
      @complete="handleComplete"
      title="Enable Google Authenticator"
    />
    <lost-otp-modal
      :contact_email="siteSetting.contact_email"
      name="lostOtpForm"
      @DISABLE_OTP_SUCCESS="disableOtpSuccess"
    />
    <confirmation-modal>
      <template slot="content">
        <div class="checkbox-bank">
          <input type="checkbox" id="c-bank" v-model="isCreateNewBankAccount" />
          <label for="c-bank">{{
            $t("refferal.confirm_bank_account_content")
          }}</label>
        </div>
      </template>
    </confirmation-modal>
    <security-level-upgrade-modal
      :visible="showUpgradeModal"
      :current-level="user.security_level || 1"
      :target-level="clickedLevel"
      @close="handleCloseUpgradeModal"
      @verify="handleVerifyUpgrade"
    />
    <div id="sumsub-wrapper" v-if="showSumsub" @click="cancelVerify">
      <div id="sumsub-websdk-container" @click="cancelVerify"></div>
    </div>
    <div class="right_list_option_acc">
      <div class="setting_top_header">
        <AccountTopHeader
          :title="$t('account.security')"
          :icon="
            require(`@/assets/images/bgr-order${
              sizeScreen > 992 ? '' : '-mobile'
            }.svg`)
          "
        />
      </div>

      <div
        v-show="Object.keys(lastLogin).length !== 0"
        class="contents_setting"
      >
        <div>
          <p class="title-medium-small">{{ $t("security.security_level") }}</p>
            <div class="security-level-wrapper">
              <!-- Level 1 -->
              <div 
                class="security-card" 
                :class="{ 
                  'active': user.security_level >= 1, 
                  'completed': user.security_level > 1, 
                  'current': user.security_level === 1,
                  'clickable': user.security_level < 1
                }"
                @click="handleLevelClick(1)"
              >
                <div class="security-card-content">
                  <div class="contents_setting_icon">
                    <img
                      :src="`/images/LV1.svg`"
                      alt="icon"
                    />
                  </div>
                  <div class="security-info">
                    <span class="security-level-title">{{ $t("security.level_1") }}</span>
                    <span class="security-level-desc">{{ $t("security.level_1_desc") }}</span>
                  </div>
                </div>
              </div>

              <!-- Level 2 -->
              <div 
                class="security-card" 
                :class="{ 
                  'active': user.security_level >= 2, 
                  'completed': user.security_level > 2, 
                  'current': user.security_level === 2,
                  'clickable': user.security_level < 2
                }"
                @click="handleLevelClick(2)"
              >
                <div class="security-card-content">
                  <div class="contents_setting_icon">
                    <img :src="`/images/icon/icon-gg-authen${dark}.svg`" alt="icon" />
                  </div>
                  <div class="security-info">
                    <span class="security-level-title">{{ $t("security.level_2") }}</span>
                    <span class="security-level-desc">{{ $t("security.level_2_desc") }}</span>
                  </div>
                </div>
              </div>

              <!-- Level 3 -->
              <div 
                class="security-card" 
                :class="{ 
                  'active': user.security_level >= 3, 
                  'completed': user.security_level > 3, 
                  'current': user.security_level === 3,
                  'clickable': user.security_level < 3
                }"
                @click="handleLevelClick(3)"
              >
                <div class="security-card-content">
                  <div class="security-icon">
                    <div class="contents_setting_icon">
                      <img :src="`/images/KYC_LV3.svg`" alt="icon" />
                    </div>
                  </div>
                  <div class="security-info">
                    <span class="security-level-title">{{ $t("security.level_3") }}</span>
                    <span class="security-level-desc">{{ $t("security.level_3_desc") }}</span>
                  </div>
                </div>
              </div>

              <!-- Level 4 -->
              <div 
                class="security-card" 
                :class="{ 
                  'active': user.security_level >= 4, 
                  'completed': user.security_level > 4, 
                  'current': user.security_level === 4,
                  'clickable': user.security_level < 4
                }"
                @click="handleLevelClick(4)"
              >
                <div class="security-card-content">
                  <div class="security-icon">
                    <div class="contents_setting_icon">
                      <img :src="`/images/LV4.svg`" alt="icon" />
                    </div>
                  </div>
                  <div class="security-info">
                    <span class="security-level-title">{{ $t("security.level_4") }}</span>
                    <span class="security-level-desc">{{ $t("security.level_4_desc") }}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div>
          <p class="title-medium-small">{{ $t("security.2fa") }}</p>
          <div class="contents_setting_container setting_border-bottom">
            <div class="contents_setting_icon">
              <img :src="`/images/icon/icon-gg-authen${dark}.svg`" alt="icon" />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group">
                    <span class="text-main text-mb">{{
                      $t("security.google_authenticator")
                    }}</span>
                    <div class="check_authen_activation">
                      {{ $t("security.sub_google_authenticator") }}
                    </div>
                    <div
                      v-if="enableOtp"
                      class="link_lost_opt"
                      @click="showModalLostOtp"
                    >
                      {{
                        $t(
                          "shared_components.google_authentication_modal.lost_code"
                        )
                      }}
                    </div>
                  </div>
                  <div class="group_btn">
                    <div class="group_status">
                      <img v-if="enableOtp" src="/images/icon/icon-verified.svg" alt="icon" />
                      <img
                        v-else
                        :src="`/images/icon/icon-un-verify${dark}.svg`"
                        alt="icon"
                      />
                      <span class="text-status">{{ 
                        enableOtp ? $t("menu.on") : $t("menu.off") 
                      }}</span>
                    </div>
                    <div class="group_btn-btn">
                      <SwitchToggle 
                        :value="enableOtp" 
                        @input="onToggleOtp" 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="title-medium-small">
            {{ $t("security.addvanced_security") }}
          </p>
          <div class="contents_setting_container setting_border-bottom">
            <div class="contents_setting_icon">
              <img
                :src="`/images/icon/icon-withdrawl-whitelist${dark}.svg`"
                alt="icon"
              />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group center_group-whitelist">
                    <span class="text-main text-mb">{{
                      $t("security.withdrawal_whitelist")
                    }}</span>
                    <div class="check_authen_activation">
                      {{ $t("security.sub_withdrawal_whitelist") }}
                    </div>
                    <div class="address_management">
                      <router-link
                        to="/account/address"
                        class="address_management-link"
                        >{{ $t("security.address_management") }}</router-link
                      >
                    </div>
                  </div>
                  <div class="group_btn">
                    <div class="group_status">
                      <img v-if="enableWhiteList" src="/images/icon/icon-verified.svg" alt="icon" />
                      <img
                        v-else
                        :src="`/images/icon/icon-un-verify${dark}.svg`"
                        alt="icon"
                      />
                      <span class="text-status">{{ 
                        enableWhiteList ? $t("menu.on") : $t("menu.off") 
                      }}</span>
                    </div>
                    <div class="group_btn-btn">
                       <SwitchToggle 
                        :value="enableWhiteList" 
                        @input="activeWhitelist" 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contents_setting_container setting_border-bottom">
            <div class="contents_setting_icon">
              <img :src="`/images/icon/icon-anti-code${dark}.svg`" alt="icon" />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group center-group-anti">
                    <span class="text-main text-mb">{{
                      $t("security.anti_phishing_code")
                    }}</span>
                    <div class="check_authen_activation">
                      {{
                        $t("security.sub_anti_phishing_code", {
                          APP_SHORT_NAME,
                        })
                      }}
                    </div>
                  </div>
                  <div class="group_btn">
                    <div class="group_status">
                      <img v-if="isAntiPhishing" src="/images/icon/icon-verified.svg" alt="icon" />
                      <img
                        v-else
                        :src="`/images/icon/icon-un-verify${dark}.svg`"
                        alt="icon"
                      />
                      <span class="text-status">{{ 
                        isAntiPhishing ? $t("menu.on") : $t("menu.off") 
                      }}</span>
                    </div>
                    <div class="group_btn-btn">
                      <!-- <SwitchToggle 
                        :value="isAntiPhishing" 
                        @input="onToggleAntiPhishing" 
                      /> -->
                      <button
                        class="btn btn-enable"
                        @click="onToggleAntiPhishing"
                      >
                        {{ isAntiPhishing ? 'Change' : 'Create' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contents_setting_container setting_border-bottom">
            <div class="contents_setting_icon">
              <img
                :src="`/images/icon/icon-change-password${dark}.svg`"
                alt="icon"
              />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group">
                    <span class="text-main text-mb">{{
                      $t("security.change_password")
                    }}</span>
                    <div class="check_authen_activation">
                      {{ $t("security.sub_change_password") }}
                    </div>
                  </div>
                  <div class="group_btn flex_end">
                    <div class="group_btn-btn">
                      <button
                        class="btn btn-enable"
                        @click="showChangePasswordModal"
                      >
                        {{ $t("account.change") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="title-medium-small">
            {{ $t("security.devices_activities") }}
          </p>
          <div class="contents_setting_container setting_border-bottom">
            <div class="contents_setting_icon">
              <img
                :src="`/images/icon/icon-device-managment${dark}.svg`"
                alt="icon"
              />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group">
                    <span class="text-main text-mb">{{
                      $t("account.device_management")
                    }}</span>
                    <div class="check_authen_activation">
                      {{ $t("security.sub_device_management") }}
                    </div>
                  </div>
                  <div class="group_btn flex_end">
                    <div class="group_btn-btn">
                      <router-link class="link" to="/account/devices">
                        <button class="btn btn-enable">
                          {{ $t("security.manage") }}
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contents_setting_container">
            <div class="contents_setting_icon">
              <img
                :src="`/images/icon/icon-accout-activity${dark}.svg`"
                alt="icon"
              />
            </div>
            <div class="preferences_group">
              <div class="group">
                <div class="group_center_option">
                  <div class="center_group">
                    <span class="text-main text-mb">{{
                      $t("security.account_activity")
                    }}</span>
                    <div class="check_authen_activation">
                      {{ $t("security.last_login") }}
                      {{ lastLogin.created_at | timestampToDate }}
                    </div>
                  </div>
                  <div class="group_btn flex_end">
                    <div class="group_btn-btn">
                      <router-link to="/account/activity">
                        <button class="btn btn-enable">
                          {{ $t("security.more") }}
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="Object.keys(lastLogin).length === 0"
        class="d-flex justify-content-center align-items-center contents_setting"
        style="max-width: initial; min-height: 100vh"
      >
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import rf from "@/request/RequestFactory";
import RemoveErrorsMixin from "@/common/RemoveErrorsMixin";
import CancelGoogleAuthModal from "@/components/shared_components/otp/CancelGoogleAuthModal";
import OtpModal from "@/components/shared_components/funds/common/OtpModal";
import EnableGoogleAuthentication from "./account/EnableGoogleAuthentication";
import VerifyOTP from "./account/modal/VerifyOTP.vue";
import ChangePassword from "./account/ChangePassword.vue";
import DeviceManager from "./account/DeviceManager.vue";
import LostOtpModal from "@/components/shared_components/otp/LostOtpModal";
import ConfirmationModal from "@/components/shared_components/common/ConfirmationModal";
import SelectBox from "@/components/shared_components/common/SelectBox";
import SecurityLevelUpgradeModal from "./account/modal/SecurityLevelUpgradeModal.vue";
import moment from "moment";
import Const from "@/common/Const";
import { getLayoutPath } from "@/routes";
import ChartContracts from "./ChartIndex.vue";
import { mapState } from "vuex";
import AccountSiteBar from "@/components/shared_components/common/AccountSiteBar.vue";
import AccountTopHeader from "@/components/shared_components/common/AccountTopHeader.vue";
import SwitchToggle from "@/components/shared_components/common/SwitchToggle.vue";
import Cookies from "js-cookie";
import snsWebSdk from "@sumsub/websdk";

import "url-search-params-polyfill";
const KYC_UNVERIFED = "unverified";
const KYC_PENDING = "pending";
const KYC_VERIFIED = "verified";
const KYC_REJECTED = "rejected";
const BANK_UNVERIFED = "unverified";
const BANK_CREATING = "creating";
const BANK_VERIFING = "verifing";
const BANK_VERIFIED = "verified";
const BANK_REJECTED = "rejected";
var sha1 = require("sha1");
export default {
  components: {
    ChartContracts,
    CancelGoogleAuthModal,
    EnableGoogleAuthentication,
    VerifyOTP,
    OtpModal,
    ChangePassword,
    LostOtpModal,
    DeviceManager,
    ConfirmationModal,
    SelectBox,
    AccountSiteBar,
    AccountTopHeader,
    SwitchToggle,
    SecurityLevelUpgradeModal
  },
  mixins: [RemoveErrorsMixin],
  data() {
    return {
      linkKycAccount: getLayoutPath({ name: "IdentityPersonal" }, true),
      linkAPIAccount: getLayoutPath({ name: "ApiCreated" }, true),
      linkAPIPage: process.env.VUE_APP_API_URL + "/api/documentation",
      isShowTooltip: false,
      showOtp: false,
      showDisableModal: false,
      tab: "main",
      enableWhiteList: undefined,
      enableLeaderboard: undefined,
      localShowFakeName: undefined,
      lastLogin: {},
      withdrawalLimitBTC: [],
      check: 0,
      showUpgradeModal: false,
      clickedLevel: 1,
      settings: {
        email: true,
        phone: false,
        bank: false,
        otp: false,
        password: false,
      },
      kyc: {
        status: "",
        bank_status: "",
      },
      user: {},
      infomation: {},
      otp: undefined,
      userSettingWhitelist: undefined,
      enableOtp: false,
      phoneVerified: false,
      enableSms: false,
      phoneNumber: "",
      emailNotification: true,
      telegramNotification: true,
      lineNotification: false,
      isCreateNewBankAccount: false,
      enableAmalFromAdmin: false,
      enableAmlPay: false,
      APP_SHORT_NAME: process.env.VUE_APP_SHORT_NAME,
      moment: moment,
      isDisableButton: false,
      siteSetting: {},
      idEncrypt: "",
      perpetual_dividend: false,
      isEditFakeName: false,
      fakeNameTemp: "",
      sizeScreen: window.innerWidth,
      isOtpVerified: false,
      showSumsub: false,
    };
  },
  watch: {
    enableAmalFromAdmin(newValue) {
      if (!newValue) {
        this.enableAmlPay = false;
      }
    },
  },
  mounted() {
    this.getUser(false);
    this.getMasterData();
    let url = window.location.href;
    if (url.includes("need-close")) {
      window.close();
    }
    this.getHistoryConnection();
    window.addEventListener("resize", this.resizeHandler);
    this.getUserSetting();
  },
  computed: {
    ...mapState({
      masterdata: (state) => state.masterdata,
      theme: (state) => state.userThemeMode,
    }),
    isVerifiableBank() {
      return (
        this.kyc.bank_status === BANK_CREATING ||
        this.kyc.bank_status === BANK_VERIFING ||
        this.kyc.bank_status === BANK_VERIFIED
      );
    },

    isAntiPhishing() {
      return !!this.settings.user_anti_phishing_active_latest;
    },
    appUrl() {
      return window.location.origin;
    },
    submittableKyc() {
      return window._.get(this, "user.security_setting.otp_verified", 0);
    },
    userSecurityLevel() {
      if (this.user.security_level > this.user.max_security_level) {
        return this.user.security_level;
      }
      return this.user.security_level || 1;
    },
    dark() {
      return this.theme === "light-theme" ? "" : "-dark";
    },
  },
  methods: {
    handleLevelClick(level) {
      if (level > this.userSecurityLevel) {
        this.clickedLevel = level;
        this.showUpgradeModal = true;
      } else if (level === 3 && this.userSecurityLevel === 3 && this.kyc.status !== KYC_VERIFIED) {
        this.verifyKYCSumsub();
      }
    },

    handleCloseUpgradeModal() {
      this.showUpgradeModal = false;
    },

    handleVerifyUpgrade(targetLevel) {
      this.showUpgradeModal = false;
      
      if (this.userSecurityLevel === 1 && targetLevel >= 2) {
        this.onClickBtnEnable2FA();
      } else if (this.userSecurityLevel === 2 && targetLevel === 3) {
        this.verifyKYCSumsub();
      }
    },
    handleEnableSMS(isOn) {
      rf.getRequest("UserRequest")
        .enableSMS({ is_enable_sms: isOn })
        .then((res) => {
          if (res && res.data) {
            this.getSecuritySettings();
            this.getUser(false);
          }
        });
    },
    async handleComplete(otp) {
      try {
        await rf.getRequest("UserRequest").verifyOtpTo2FA(otp);
        this.showSuccess(this.$t("account.otp.success")); 
        this.showOtp = false;
        window.CommonModal.show("EnableGoogleAuthentication");
      } catch(e) {
        console.error(e);
        if (e.response && e.response.data && e.response.data.message) {
           Message.error(e.response.data.message);
        }
      }
    },
    async handleCompleteDisable(otp) {
      try {
        await rf.getRequest("UserRequest").verifyOtpTo2FA(otp);
        this.showSuccess(this.$t("account.otp.success"));
        this.showDisableModal = false;
        window.CommonModal.show("CancelGoogleAuthModal");
      } catch(e) {
        console.error(e);
        if (e.response && e.response.data && e.response.data.message) {
           Message.error(e.response.data.message);
        }
      }
    },
    onSaveFakeName() {
      rf.getRequest("UserRequest")
        .onUpdateFakeName({ fake_name: this.fakeNameTemp })
        .then((res) => {
          if (res && res.data) {
            this.user.fake_name = this.fakeNameTemp;
            this.isEditFakeName = false;
            this.getUser(false);
            this.showSuccess(this.$t("mam.update.success"));
          }
        });
    },
    activeLeaderboard() {},
    getLinkPnlChart() {
      rf.getRequest("UserRequest")
        .getLinkPnlChart({ name: "Pnl-Chart" })
        .then((res) => {
          const path = APP_URL + "/pnl-chart?token=" + res.data.id;
          // if (!navigator.clipboard) {
          //   Utils.fallbackCopyTextToClipboard(path);
          //   return;
          // }
          // navigator.clipboard.writeText(path);
          // this.$router.push({ name: 'PNLChart', query: {token: res.data.id} });
          window.open(path, "_blank");
        });
    },
    convertDate(date) {
      var dateFormat = "YYYY-MM-DD HH:mm:ss";
      var testDateUtc = moment.utc(date);
      var localDate = testDateUtc.local();
      return localDate.format(dateFormat);
    },
    addChannelTelegram: function (userID) {
      document.getElementById("cancel_focus_telegram").blur();
      this.listenForTelegramLine(userID);
      let apiTelegram = process.env.VUE_APP_MIX_API_TELEGRAM + userID;
      window.open(apiTelegram, "_blank");
    },

    getParamsUpdateModeWhitelist() {
      return {
        active: !this.userSettingWhitelist,
      };
    },
    listenForTelegramLine(userId) {
      window.Echo.private("App.User." + userId).listen(
        "UserNotificationUpdated",
        (res) => {
          let channel = res.data.channel;
          let is_enable = res.data.is_enable;
          if (channel === "line") {
            this.lineNotification = is_enable;
          }
          if (channel === "mail") {
            this.emailNotification = is_enable;
          }
          if (channel === "telegram") {
            this.telegramNotification = is_enable;
          }
        }
      );
    },
    async redirectLine(userID) {
      await this.encryptId();
      document.getElementById("cancel_focus_line").blur();
      if (userID) {
        let callback_uri =
          this.$router.resolve({ name: "Account" }).href + "?need-close";
        let state = userID + "&" + this.idEncrypt + "$" + callback_uri;
        let client_id = process.env.VUE_APP_MIX_LINE_CLIENT_ID;
        let redirect_uri =
          process.env.VUE_APP_API_URL + "/api/v1/get-auth-code";
        let response_type = "code";
        let url = "https://notify-bot.line.me/oauth/authorize?";
        let scope = "notify";
        var searchParams = new URLSearchParams("");
        searchParams.append("client_id", client_id);
        searchParams.append("redirect_uri", redirect_uri);
        searchParams.append("response_type", response_type);
        searchParams.append("scope", scope);
        searchParams.append("state", state);
        url = url + searchParams;
        window.open(url, "_blank");
      }
    },
    changeWalletFee(type) {
      if (this.tab != type && this.enableAmlPay) {
        this.tab = type;
        let param = {
          wallet_name: type,
        };
        rf.getRequest("UserRequest")
          .changeTypeWalletAmalPayFee(param)
          .then((res) => {});
      }
    },

    showChannelModal(type, channel) {
      if (type === "disable") {
        window.ConfirmationModal.show({
          type:
            channel === "email"
              ? "disableEmail"
              : channel === "telegram"
              ? "disableTelegram"
              : channel === "line"
              ? "disableLine"
              : "",
          title: "",
          content:
            channel === "email"
              ? this.$t("account.email_disable_confirm")
              : channel === "telegram"
              ? this.$t("account.email_disable_confirm")
              : channel === "line"
              ? this.$t("account.email_disable_confirm")
              : "",
          btnCancelLabel: window.i18n.t("common.action.no"),
          btnConfirmLabel: window.i18n.t("common.action.yes"),
          onConfirm: () => {
            this.actionNotification(type, channel);
          },
        });
      } else {
        document.getElementById("cancel_focus_mail").blur();
        this.actionNotification(type, channel);
      }
    },
    actionNotification(type, channel) {
      let param = {
        active: 1,
      };
      if (type === "disable") {
        param.active = 0;
      } else {
        param.active = 1;
      }
      if (channel === "email") {
        rf.getRequest("UserRequest")
          .changeEmailNotification(param)
          .then((res) => {
            this.getUserNotification();
          });
      }
      if (channel === "telegram" && param.active == 0) {
        rf.getRequest("UserRequest")
          .changeTelegramNotification(param)
          .then((res) => {
            this.getUserNotification();
          });
      }
      if (channel === "line") {
        rf.getRequest("UserRequest")
          .changeLineNotification(param)
          .then((res) => {
            this.getUserNotification();
          });
      }
    },
    showTooltip() {
      this.isShowTooltip = !this.isShowTooltip;
    },
    verifyKYCSumsub() {
      this.startVerification();
    },
    async getNewAccessToken() {
      const res = await rf.getRequest("UserRequest").getNewToken();
      return Promise.resolve(res?.token);
    },
    cancelVerify() {
      this.showSumsub = false;
      const elementSumsub = document.getElementById("sumsub-websdk-container");
      if (elementSumsub) elementSumsub.style.display = "none";
      document.body.style.overflowY = "auto";
    },
    async startVerification() {
      if (this.showSumsub) return;
      let accessToken = "";
      this.showSumsub = true;
      await rf.getRequest("UserRequest")
        .getNewToken()
        .then((res) => {
          accessToken = res.token;
        });

      let snsWebSdkInstance = snsWebSdk
        .init(
          accessToken,
          // token update callback, must return Promise
          // Access token expired
          // get a new one and pass it to the callback to re-initiate the WebSDK
          () => this.getNewAccessToken()
        )
        .withConf({
          lang: Cookies.get("locale", {
            domain: process.env.VUE_APP_PUBLIC_URL,
          }),
          uiConf: {
            customCssStr:
              ":root {\n  --black: #000000;\n   --grey: #fff;\n  --primary-color:var(--text-primary-color);\n   --grey-darker: #B2B2B2;\n  --border-color: #DBDBDB;\n}\n\np {\n  color: var(--black);\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.steps {\n display: none;\n}\n\nsection {\n  margin: 0px auto;\n}\n\ninput {\n  color: var(--black);\n  font-weight: 600;\n  outline: none;\n}\n\nsection.content {\n  background-color: var(--grey);\n  color: var(--black);\n  padding: 40px 40px 16px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n\nbutton.submit,\nbutton.back {\n  text-transform: capitalize;\n  border-radius: 6px;\n  height: 48px;\n  padding: 0 30px;\n  font-size: 16px;\n  background-image: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  transition: all 0.2s linear;\n}\n\nbutton.submit {\n  min-width: 132px;\n  background: none;\n  background-color: var(--black);\n}\n\n.content {\n height: 100vh !important;\n overflow: auto;   }\n\n.round-icon {\n  background-color: var(--black) !important;\n  background-image: none !important;\n}\n\n.sumsub-logo {\n margin-top: -34px;}\n\n.iframe2{\n margin: 0;}\n\n#loader{\n position: absolute;\n top: 50%;\n left: 50%;\n transform: translate(-50%, -50%);\n margin: 0; }",
          },
        })
        .withOptions({ addViewportTag: true, adaptIframeHeight: false })
        .on("idCheck.onApplicantLoaded", (payload) => {})
        .on("idCheck.onStepCompleted", (payload) => {
          console.log("onStepCompleted", payload);
        })
        .on("idCheck.onError", (error) => {
          console.log("onError", error);
        })
        .build();

      snsWebSdkInstance.launch("#sumsub-websdk-container");
      const iframes = document.getElementsByTagName("iframe"); 
        for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        if (iframe.getAttribute("src")?.includes("sumsub")) {
          const isMobile = window.matchMedia('(max-width: 940px)').matches
          iframe.style.height = "100vh";
        }
      }
    },
    hideTooltip() {
      this.isShowTooltip = false;
    },
    showCancelGoogleAuthModal() {
      window.CommonModal.show("CancelGoogleAuthModal");
    },
    showChangePasswordModal() {
      window.CommonModal.show("ChangePassword");
      this.$refs.changePassComponent.resetData();
    },
    hideCancelGoogleAuthModal() {
      window.CommonModal.hide("CancelGoogleAuthModal");
      this.getSecuritySettings();
      this.getUser(false);
    },
    hideEnableGoogleAuthenticaion() {
      window.CommonModal.hide("EnableGoogleAuthentication");
      this.getSecuritySettings();
      this.getUser(false);
    },
    showEnableOtpModal() {
      window.CommonModal.show("EnableGoogleAuthentication");
    },
    showModalLostOtp() {
      window.CommonModal.show("lostOtpForm");
    },
    disableOtpSuccess() {
      this.getSecuritySettings();
      this.getUser(false);
    },
    loadDataImmediately() {
      this.getUserSettings();
      this.getUserNotification();
      this.getSecuritySettings();
      this.getUser();
      this.getWithdrawalLimitBTC();
      this.getUserKyc();
      this.getDividendSettings();
    },
    getSecuritySettings() {
      rf.getRequest("UserRequest")
        .getSecuritySettings()
        .then((res) => {
          this.settings = Object.assign({}, this.settings, res);
          this.enableOtp = window._.get(this, "settings.otp_verified", 0);
          this.phoneVerified = window._.get(this, "settings.phone_verified", 0);
          this.enableSms = window._.get(this, "settings.is_enable_sms", 0);
        });
    },
    getUserKyc() {
      rf.getRequest("UserRequest")
        .getUserKyc()
        .then((res) => {
          this.kyc = res.data || {};
          this.isCreateNewBankAccount = this.kyc.bank_status === BANK_CREATING;
        });
    },
    async encryptId() {
      await rf
        .getRequest("UserRequest")
        .encryptId()
        .then((res) => {
          this.idEncrypt = sha1(res.toString()) || {};
        });
    },
    getDividendSettings() {
      rf.getRequest("UserRequest")
        .getDividendSetting()
        .then((res) => {
          this.enableAmalFromAdmin = res.data?.enable_fee_amal || false;
          this.perpetual_dividend = res.data?.enable_wallet_pay_fee || false;
        });
    },
    getHistoryConnection(params) {
      const promise = rf.getRequest("UserRequest").getHistoryConnection(params);
      this.getLatest(promise);
      return promise;
    },
    getLatest(promise) {
      promise.then((res) => {
        this.lastLogin = res.data[0];
      });
    },

    getUserNotification() {
      rf.getRequest("UserRequest")
        .getUserNotificationSettings()
        .then((res) => {
          const emailNotification =
            _.find(res.data, (item) => {
              return item.channel === "mail";
            }) || {};

          this.emailNotification = emailNotification.is_enable === 1;

          const telegramNotification =
            _.find(res.data, (item) => {
              return item.channel === "telegram";
            }) || {};

          this.telegramNotification = telegramNotification.is_enable === 1;

          const lineNotification =
            _.find(res.data, (item) => {
              return item.channel === "line";
            }) || {};
          this.lineNotification = lineNotification.is_enable === 1;
        });
    },

    getUserSettings() {
      rf.getRequest("UserRequest")
        .getUserSettings()
        .then((res) => {
          const setting =
            _.find(res.data, (item) => {
              return item.key === "whitelist";
            }) || {};
          this.userSettingWhitelist = this.enableWhiteList = !!parseInt(
            setting.value
          );

          const amlPay =
            _.find(res.data, (item) => {
              return item.key === "amal_pay";
            }) || {};
          const amlWalletPay =
            _.find(res.data, (item) => {
              return item.key === "amal_pay_wallet";
            }) || {};
          this.enableAmlPay = amlPay.value === "1";
          if (amlWalletPay && amlWalletPay.value) {
            this.tab = amlWalletPay.value;
          }
        });
    },
    getUser(useCache = true) {
      rf.getRequest("UserRequest")
        .getCurrentUser(useCache)
        .then((res) => {
          this.user = Object.assign({}, this.user, res.data);
          this.listenForTelegramLine(res.data.id);
          this.localShowFakeName = this.user.security_setting.use_fake_name;
          this.phoneNumber = this.user.phone_number;
          return (this.enableLeaderboard =
            this.user.security_setting.use_fake_name);
        });
    },
    getWithdrawalLimitBTC() {
      rf.getRequest("UserRequest")
        .getWithdrawalLimitBTC()
        .then((res) => {
          this.withdrawalLimitBTC = res.data;
        });
    },
    activeWhitelist() {
      const message = this.userSettingWhitelist
        ? this.$t("account.turn_off_mode_whitelist")
        : this.$t("account.turn_on_mode_whitelist");
      const title = this.userSettingWhitelist
        ? this.$t("address.disable_whitelist")
        : this.$t("address.enable_whitelist");
      const btnCancelLabel = this.$t("account.cancel");
      const btnConfirmLabel = this.userSettingWhitelist
        ? this.$t("account.disable")
        : this.$t("account.enable");
      const icon =
        this.theme === "light-theme"
          ? "/images/icon/icon-enable-whitelist.svg"
          : "/images/icon/icon-enable-whitelist-dark.svg";
      this.showModal({
        width: 560,
        type: "primary",
        title,
        icon,
        content: message,
        btnCancelLabel,
        btnConfirmLabel,
        onConfirm: () => {
          if (this.enableOtp) {
            window.CommonModal.show("otp_modal");
            this.enableWhiteList = this.userSettingWhitelist;
          } else {
            const params = this.getParamsUpdateModeWhitelist();
            this.updateModeWhitelist(params);
          }
        },
        onCancel: () => {
          this.enableWhiteList = this.userSettingWhitelist;
        },
      });
    },
    showModalLostOtp() {
      window.CommonModal.show("lostOtpForm");
    },
    updateModeWhitelist(params) {
      this.isDisableButton = true;
      return rf
        .getRequest("UserRequest")
        .activeWhitelist({
          active: params.active ? true : false,
          otp: params.otp,
        })
        .then((response) => {
          this.isDisableButton = false;
          window.CommonModal.hide("otp_modal");
          this.userSettingWhitelist = this.enableWhiteList =
            response.data.whitelist;
          
          const successMessage = this.userSettingWhitelist
            ? this.$t("account.whitelist_enabled_success") || "Enable Withdrawal Whitelist successfully!"
            : this.$t("account.whitelist_disabled_success") || "Disable Withdrawal Whitelist successfully!";
          Message.success(successMessage, {}, { position: "bottom_right" });
        })
        .catch((error) => {
          this.isDisableButton = false;
          this.errors.add(
            "otp",
            window.i18n.t(
              error.response.data.message || "common.message.network_error"
            )
          );
        });
    },
    activeLeaderboard() {
      const message = this.enableLeaderboard
        ? window.i18n.t("leaderboard.show_fake_username")
        : window.i18n.t("leaderboard.show_real_username");
      this.showModal({
        title: "",
        content: message,
        btnCancelLabel: window.i18n.t("common.action.no"),
        btnConfirmLabel: window.i18n.t("common.action.yes"),
        onConfirm: () => {
          this.updateLeaderboard();
        },
        onCancel: () => {
          this.enableLeaderboard = !this.enableLeaderboard ? 1 : 0;
        },
      });
    },
    updateLeaderboard() {
      let params = {
        use_fake_name: !this.enableLeaderboard ? 0 : 1,
      };
      rf.getRequest("UserRequest")
        .activeLeaderBoard(params)
        .then((res) => {
          this.localShowFakeName = res.data;
        })
        .catch((err) => {
          this.localShowFakeName = 0;
        });
    },
    showSuccess(message) {
      Message.success(message, {}, { position: "bottom_left" });
    },
    onToggleAntiPhishing() {
      if (this.isAntiPhishing) {
        this.$router.push("/account/anti-phishing/change");
      } else {
        this.$router.push("/account/anti-phishing/create");
      }
    },
    onToggleOtp() {
      if (this.enableOtp) {
        this.onClickBtnDisable2FA();
      } else {
        this.onClickBtnEnable2FA();
      }
    },
    onClickBtnEnable2FA() {
      try {
        rf.getRequest("UserRequest").sendOTPToEmail(this.user.email);
        this.showOtp = true;
      } catch (error) {
        console.log(error);
      }
    },
    onClickBtnDisable2FA() {
      try {
        rf.getRequest("UserRequest").sendOTPToEmail(this.user.email);
        this.showDisableModal = true;
      } catch (error) {
        console.log(error);
      }
    },
    getSocketEventHandlers() {
      return {
        OtpUpdated: this.getSecuritySettings,
      };
    },
    verifyBankAccount(status) {
      rf.getRequest("UserRequest")
        .updateBankAccountStatus(status)
        .then((res) => {
          this.getUserKyc();
        });
    },
    verifyBankModal() {
      if (this.kyc.status !== KYC_VERIFIED) {
        this.showModal({
          type: "warning",
          title: "Error",
          content: this.$t("refferal.alert_bank_account_content"),
          noAction: true,
        });
        return;
      }
      this.showModal({
        type: "confirm",
        title: this.$t("refferal.confirm_bank_account_title"),
        customContent: true,
        onConfirm: () => {
          this.verifyBankAccount({
            status: this.isCreateNewBankAccount ? BANK_CREATING : BANK_VERIFING,
          });
        },
      });
    },
    showModal(config) {
      const type = config.type;
      const title = config.title;
      const content = config.content;
      const customContent = config.customContent;
      let btnCancelLabel = config.btnCancelLabel || this.$t("common.action.no");
      let btnConfirmLabel =
        config.btnConfirmLabel || this.$t("common.action.yes");
      if (config.noAction) {
        btnCancelLabel = null;
        btnConfirmLabel = null;
      }
      const onConfirm = config.onConfirm;
      const onCancel = config.onCancel;
      window.ConfirmationModal.show({
        widthModal: config.width,
        icon: config.icon || null,
        type: type,
        title: title,
        content: content,
        customContent: customContent,
        btnCancelLabel: btnCancelLabel,
        btnConfirmLabel: btnConfirmLabel,
        onConfirm: onConfirm,
        onCancel: onCancel,
      });
    },
    onClickedVerifyGoogleAuthen(pathRoute) {
      if (!this.submittableKyc) {
        Message.error(
          this.$t("account.otp.should_enable_first"),
          {},
          { position: "bottom_left" }
        );
        return;
      }
      this.$router.push({ path: pathRoute });
    },
    activeAmlPay() {
      if (this.enableAmalFromAdmin) {
        let param = {
          active: !this.enableAmlPay ? 1 : 0,
        };
        rf.getRequest("UserRequest")
          .changeAmlPay(param)
          .then((res) => {});
      }
    },
    getUserDevice(params) {
      const promise = rf.getRequest("UserRequest").getUserDevice(params);
      return promise;
    },
    onDatatableFinished() {
      if (!this.$refs.datatableDevice || !this.$refs.datatableDevice.rows) {
        return;
      }
      window._.each(this.$refs.datatableDevice.rows, (item) => {
        item.isActiveRow = false;
      });
    },
    activeRow(item) {
      item.isActiveRow = !item.isActiveRow;
      this.$forceUpdate();
    },
    refreshDevice() {
      this.$refs.datatableDevice.refresh();
    },
    confirmRemoveDevice(deviceId) {
      window.ConfirmationModal.show({
        type: "primary",
        title: "",
        content: this.$t("account.modal.confirm_trusted_device"),
        btnCancelLabel: window.i18n.t("common.action.no"),
        btnConfirmLabel: window.i18n.t("common.action.yes"),
        onConfirm: () => {
          this.removeDevice(deviceId);
        },
        onCancel: () => {},
      });
    },
    removeDevice(deviceId) {
      rf.getRequest("UserRequest")
        .deleteDevice(deviceId)
        .then((res) => {
          this.refreshDevice();
          Message.success(window.i18n.t("address.deleted_success"));
        });
    },

    getMasterData() {
      window._.each(this.masterdata.settings, (item) => {
        this.siteSetting[item.key] = item.value;
      });
    },
    resizeHandler() {
      this.sizeScreen = window.innerWidth;
    },
  },
  created() {
    this.loadDataImmediately();
    document.title = this.$t("menu.account") + ` – ${this.tabTitle}`;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables";

#sumsub-wrapper {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

#sumsub-websdk-container {
  min-width: 700px;
  margin: auto;
  height: 100vh;
  @media screen and (max-width: 740px) {
    margin-left: 20px;
    margin-right: 20px;
  }

  iframe {
    min-height: 100vh !important;
  }

}

.loader {
  display: block;
  margin: auto;
  border: 5px solid $color-grey-concrete;
  border-radius: 50%;
  border-top: 5px solid $color-blue-custom;
  width: 40px;
  height: 40px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#account {
  .group_custom {
    min-height: 405px;
    .group {
      width: 100%;
      margin-bottom: 10px;
      padding-right: 20px;
      .mgt38 {
        margin-top: 47px;
      }
    }
  }
  .group_custom-2 {
    min-height: inherit;
    .group {
      margin-bottom: 0px;
    }
  }
  .disabled_item {
    background-color: $color-bright-gray;
    border: none;
    cursor: not-allowed;
    pointer-events: none;
    color: $color_black;
    border: solid 1px $color-alto;
  }
  .break_boder {
    width: calc(100% - 30px - 30px - 15px);
    height: 1px;
    opacity: 0.7;
    border-radius: 1px;
    background-color: $color-alto;
    clear: both;
    margin: auto;
  }
  .checkbox-bank {
    label {
      display: inline;
      font-weight: normal;
    }
  }
  .table-device {
    margin-top: 15px;
    .icon-close,
    .glyphicon {
      font-weight: 600;
      font-size: 16px;
      color: $color-green;
      &:hover,
      &:focus {
        color: $color-eden;
      }
    }
    .glyphicon {
      font-weight: normal;
      font-size: $font-medium;
    }
    tr {
      height: auto;
      &.double_tr {
        padding: 0 25px;
        th {
          font-size: $font-root;
          color: $color-grey;
          padding: 15px 0px;
          line-height: 20px;
          width: 31%;
          &:nth-child(4) {
            width: 3.5%;
          }
          &:nth-child(5) {
            width: 3.5%;
          }
        }
      }
      &.device-manager {
        padding: 0 25px;
        &:hover {
          background-color: $color-bright-gray;
        }
        th {
          &.active {
            max-height: 300px;
            transition-property: height;
            transition-duration: 0.3s, 0.3s;
            transition-timing-function: ease, ease-in;
            .glyphicon-menu-down {
              transition-duration: 0.5s;
              transform: rotate(180deg);
            }
          }
        }
        td {
          text-align: left;
          width: 31%;
          font-weight: 600;
          &:nth-child(4) {
            width: 3.5%;
          }
          &:nth-child(5) {
            width: 3.5%;
          }
        }
      }
    }
    .odd {
      background-color: $color-white;
    }
    .actions {
      cursor: pointer;
      color: $color-grey !important;
    }
  }
  .datatable {
    tr {
      &.empty-data {
        td {
          width: 100%;
        }
      }
      height: auto;
      &:hover {
        background-color: $color-bright-gray;
      }
      &.double_tr {
        padding: 0 25px;
        th {
          font-size: $font-root;
          color: $color-grey;
          padding: 15px 0px;
          line-height: 20px;
          font-size: 13px;
        }
      }
      th {
        width: 33.33%;
      }
      td {
        font-size: $font-root;
        color: $color-grey-dark;
        padding: 10px 0px;
        line-height: 20px;
        width: 33.33%;
      }
      &.last-login {
        text-align: left;
        padding: 0 25px;

        td {
          font-weight: 600;
          color: $color-grey-dark;
          &:last-child {
            text-align: left;
          }
        }
      }
    }
  }
  .table_min {
    table {
      background-color: $color-white;
      border-top: 0px;
      thead {
        height: auto;
        background: $color-white;
      }
    }
  }
}
.scroll-table table tbody {
  height: auto !important;
  margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
@import "@/assets/sass/variables";
#chart_contracts {
  height: calc(100vw * 0.35);
  min-height: 495px;
  border: 1px solid $color-grey;
  margin-top: 15px;
}
.disable-class {
  cursor: not-allowed;
}
.fake-name-contain {
  color: #666666;
  font-size: 13px;
  margin: 10px 0;
  .fake-name-span {
    word-break: break-all;
  }
  span {
    color: #333;
  }
  .action-button-wrapper {
    display: inline-block;
  }
  .btn_edit_network,
  .btn_save_network,
  .btn_close_network {
    color: $color-jungle-green;
    padding: 5px 6px;
    line-height: 23px;
    &:active {
      box-shadow: inset 0 0px 0px rgba(0, 0, 0, 0);
    }
    .icon-edit:before,
    .icon-save:before,
    .icon-close2:before {
      color: $color-jungle-green;
    }
    &:hover {
      .icon-edit:before,
      .icon-save:before,
      .icon-close2:before {
        color: $color-blue-custom;
      }
    }
  }
}
.group-flex {
  display: flex;
  .group-wallet {
    margin-right: 15px;
    margin-top: 47px;
    border: none;
    .dropdown {
      button {
        border: none;
        display: flex;
        color: #333333;
        height: 40px;
        background: #ffffff;
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.54;
        min-width: 201px;
        justify-content: space-between;
        .paddingt-2 {
          padding-top: 2px;
          span.icon-arrow1 {
            margin-left: 23px;
            color: #2dac91;
          }
        }
      }
      ul.dropdown-menu {
        min-width: 201px;
        .tab-element {
          text-align: left;
          min-height: 35px;
          padding-top: 7px;
          padding-left: 10px;
          &:hover {
            background: #2dac91;
            color: white;
          }
        }
      }
    }
  }
}
.title-medium-small {
  font-family: $font-inter-bold;
  color: var(--text-primary-color);
  font-size: 30px;
  line-height: 36px;
  margin-bottom: 43px;
  text-transform: none;
}
.white-list-height {
  line-height: 23px;
}
.account_container {
  display: inline-block;
  width: 100%;
  padding: 0px;
  background-color: var(--color-black);
}
.path_acount_container {
  display: flex;
  gap: 4px;
}
.path_leaderboard {
  margin-top: 40px;
  .content_pick_leaderboard {
    margin-top: 15px;
    background-color: $color-white;
    padding: 15px;
    font-weight: 500;
    font-size: $font-small;
    color: $color-grey-dusty;
    line-height: 23px;
  }
}
.path_address_container {
  display: flex;
  width: 100%;
  height: 300px;
  margin-top: 15px;
}
.path_device_management {
  width: 100%;
  margin-top: 60px;
}
.path_last_login {
  display: inline-block;
  width: 100%;
  margin-top: 55px;
  table {
    thead {
      tr {
        th {
          font-size: $font-smaller;
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: $font-small;
        }
      }
    }
  }
}
.acount_info {
  overflow: hidden;
  width: 100%;
  margin-bottom: 65px;
  .left_acc_info {
    width: 475px;
    max-width: 50%;
    margin-right: -1px;
    padding-right: 5px;
    padding-bottom: 10px;
    .sub_acc_info {
      display: block;
      overflow: hidden;
      padding-bottom: 8px;
    }
    .email_acc {
      margin-bottom: 12px;
      font-size: $font-medium-bigger;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-black;
    }
  }
  .right_acc_info {
    width: calc(100% - 475px);
    border-left: 1px solid $color-alto;
    min-width: 50%;
    padding-bottom: 10px;
  }
}
.login_password {
  width: 100%;
  background-color: transparent;
}
.ni_bank_acc {
  width: 20.5%;
  min-width: 236px;
  height: 100%;
  margin-right: 15px;
  background-color: $color-white;
  text-align: center;
  .icon-bank {
    font-size: 60px;
    width: 60px;
    height: 60px;
    margin-top: 80px;
    margin-bottom: 20px;
    color: $color-grey-sliver;
  }
  .text_bank {
    font-size: $font-big-20;
    line-height: 22px;
    color: $color-black;
    font-weight: 600;
    margin-bottom: 9px;
  }
  .butt_unver_bank {
    background: $color-blue-cerulean-light;
    color: $color-white;
    font-size: $font-small;
    font-weight: 700;
    height: 21px;
    line-height: 21px;
    padding: 0px 11px;
    border-radius: 15px;
    margin-bottom: 25px;
  }
  .butt_verify_bank {
    width: 110px;
    height: 32px;
    border: 1px solid $color-yellow;
    color: $color-yellow;
    font-size: $font-small;
    font-weight: 700px;
    text-align: center;
    padding: 5px 10px;
    line-height: 22px;
    background: transparent;
    border-radius: 20px;
    font-weight: 700;
    margin-bottom: 47px;
  }
  .error_bank_acc {
    color: $color-red-warning;
    font-size: $font-small;
    line-height: 20px;
    width: 165px;
    text-align: center;
  }
}
.google_authen {
  width: 100%;
  height: 100%;
  background-color: transparent;
  text-align: center;
  .form-check-label {
    margin-top: 18px;
    a {
      font-size: $font-small;
    }
  }
}
.background_white {
  background-color: transparent;
}
.referral_program {
  width: 100%;
  background-color: transparent;
}
.text_title_table {
  color: $color-eden;
  margin-bottom: 15px;
}
.table_descripe {
  padding-left: 11px;
  color: $color-grey-dusty;
}
.device_table {
  width: 100%;
  height: 100px;
  background-color: $color-white;
}
.login_table {
  width: 100%;
  height: 250px;
  background-color: $color-white;
}
.fs11 {
  font-size: $font-mini;
}
.fs12 {
  font-size: $font-smaller;
}
.fs13 {
  font-size: $font-small;
}
.fs20 {
  font-size: $font-big-20;
}
.img-user {
  width: 110px;
  height: 110px;
  margin: auto;
  margin-right: 25px;
  display: block;
}
.lv_content {
  width: auto;
  display: inline-block;
  height: 24px;
  margin: auto;
  text-align: center;
  font-weight: 600;
  margin-bottom: 15px;
  max-width: 100%;
}
.rejected {
  width: 300px;
}
.btn_common {
  border-radius: 3px;
  padding-left: 17px;
  padding-right: 17px;
  width: auto;
  min-width: 85px;
  text-align: center;
  height: 23px;
  display: flex;
  align-items: center;
  color: $color-white;
  text-transform: uppercase;
}
.lv_text {
  display: flex;
  align-items: center;
  height: 23px;
  width: 40px;
  color: $color-corn-pale;
  font-size: 16px;
}
.btn_unverified {
  background-color: $color-eden;
  color: $color-white;
  margin-right: 5px;
  cursor: pointer;
  width: 90px;
  line-height: 20px;
  padding: 3px;
  text-align: center;
}
.btn_verified {
  background-color: $color-curious-blue;
  color: $color-white;
  margin-right: 5px;
  cursor: pointer;
}
.btn_pending {
  background-color: $color-corn-pale;
  color: $color-white;
  margin-right: 5px;
  cursor: pointer;
}
.btn_rejected {
  background-color: $color-thunderbird;
  color: $color-white;
  margin-right: 5px;
  cursor: pointer;
}
.btn_general {
  background-color: $color-grey;
}
.margin_auto {
  margin: auto;
}
.text_acount {
  color: $color-grey-dusty;
  font-size: $font-small;
  line-height: 20px;
  .text_discount {
    color: $color-grey-dark;
  }
}
.withdraw_limit_map {
}
.submit_contact {
  font-size: $font-small;
  color: $color-yellow;
  height: 20px;
  margin-top: 10px;
  text-align: center;
  padding-left: 52px;
  div {
    height: 25px !important;
  }
}
.submit {
  width: 200px;
  color: $color-curious-blue;
}
.border_bot {
  border-bottom: 1px solid $color-yellow;
}
.contact_us {
  width: 100px;
  color: $color-curious-blue;
  margin-right: 18px;
}
.h-18 {
  height: 18px;
}
.icon-login-password {
  font-size: 50px;
  width: 50px;
  height: 50px;
  color: $color-grey-sliver;
}
.icon-referral-program {
  font-size: 50px;
  width: 50px;
  height: 50px;
  color: $color-grey-sliver;
}
.icon-shield {
  font-size: 50px;
  width: 50px;
  height: 50px;
  color: $color-grey-sliver;
}
.text_login {
  font-size: $font-medium-bigger;
  font-weight: bold;
  line-height: normal;
  color: $color-black;
}
.btn_account {
  height: 35px;
  margin-right: 15px;
  width: 110px;
  text-align: center;
  border-radius: 3px;
  font-weight: 600;
  border: 1px solid $color-jungle-green;
  color: $color-white;
  font-size: $font-smaller;
  text-transform: uppercase;
  display: inline-block;
  padding: 7px 0px;
  line-height: 20px;
  overflow: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  background-color: $color-jungle-green;
  &:hover,
  &:active,
  &:focus {
    background-color: $color-blue-custom;
    border-color: $color-blue-custom;
    color: $color-white;
    outline: none;
  }
}
.btn_border {
  background-color: transparent;
  color: $color-jungle-green;
  &:hover,
  &:active,
  &:focus {
    background-color: $color-blue-custom;
    border-color: $color-blue-custom;
    color: $color-white;
  }
}
.btn_info {
  background-color: $color-curious-blue;
  border-color: $color-curious-blue;
  &:hover,
  &:active,
  &:focus {
    background-color: $color-blue-custom-2;
    border-color: $color-blue-custom-2;
    outline: none;
  }
}
.marr10 {
  margin-right: 10px;
}
.referral_program {
  .btn_active {
    width: 150px;
  }
}
.text_white {
  color: $color-white;
}
.text_yellow {
  color: $color-yellow;
}
.icon-note {
  font-size: $font-big-20;
  width: 20px;
  height: 20px;
}
.tooltip-order {
  width: 200px;
  height: 200px;
  background-color: $background-default;
  z-index: 1000;
  border: 1px solid $color-grey-border;
  position: absolute;
  border-radius: 15px;
  color: $color-grey-dark;
  font-weight: normal;
  font-size: $font-small;
  box-shadow: 1px 1px 1px 1px $color-grey-border;
  line-height: 20px;
}
.text-tooltip {
  margin: 10px 10px 10px;
}
.road_lv {
  width: 100%;
  padding: 0px 0px 0px 50px;
  overflow: hidden;
  padding-bottom: 5px;
  .item_road {
    text-align: center;
    &:last-child {
      .icon-diamond-1 {
        margin-right: 0px;
        text-align: right;
      }
    }
    &:first-child {
      .icon-diamond-1 {
        margin-left: 0px;
        text-align: center;
      }
    }
    .text_milestone {
      font-size: $font-small;
      color: $color-grey-dusty;
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 15px;
      .nb_read_item {
        color: $color-grey-dark;
        font-size: $font-root;
        font-weight: 600;
      }
    }
  }
}
.milestone {
  width: 100%;
  border-bottom: 2px solid $color-eden;
}
.title_step {
  width: 100%;
}
.icon-diamond-1 {
  margin: auto;
  text-align: center;
  margin-top: 4px;
  font-size: $font-big-20;
  position: relative;
  padding-bottom: 6px;
  color: $color-eden;
  width: 100%;
  div {
    width: 100%;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  strong {
    font-size: $font-medium-bigger;
    color: $color-eden;
    font-weight: 600;
    padding-left: 5px;
    padding-left: 5px;
    font-size: $font-medium-bigger;
    line-height: normal;
    color: $color-eden;
  }
  strong.step_active {
    color: $color-corn-pale;
  }
}
.right_list_option_acc {
  background-color: var(--background-home-page);

  flex: 1;
  .contents_setting {
    max-width: 1320px;
    padding: 36px 0px 36px 43px;
    .contents_setting_container {
      display: flex;
      gap: 28px;
      margin-bottom: 30px;
      &.setting_border-bottom {
        border-bottom: 2px solid var(--color-border);
      }
      .text-main {
        font-family: $font-inter-bold;
        font-size: 20px;
        line-height: 24px;
        color: var(--text-primary-color);
      }
      .contents_setting_icon {
        width: 52px;
      }
      .preferences_group {
        flex: 1;
        .check_authen_activation {
          font-family: $font-inter-regular;
          font-size: 16px;
          line-height: 20px;
          color: var(--text-close);
          max-width: 472px;
          margin-top: 5px;
        }
        .address_management {
          margin-top: 5px;
          .address_management-link {
            font-family: $font-inter-regular;
            font-size: 16px;
            line-height: 20px;
            color: $color-aqua-green;
            text-decoration: underline;
            margin-top: 5px;
          }
        }
        .group-text-main {
          margin-bottom: 43px;
        }
        .group {
          margin-bottom: 30px;
          .group_center_option {
            display: flex;
            .text-mb {
              margin-bottom: 5px;
            }
            .center_group {
              flex: 1;
              .link_lost_opt {
                font-family: $font-inter-regular;
                font-size: 16px;
                line-height: 20px;
                color: $color-aqua-green;
                text-decoration: underline;
                margin-top: 5px;
                display: inline-block;
                cursor: pointer;
              }
            }
            .group_btn {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
              &.flex_end {
                justify-content: flex-end;
              }
              .group_status {
                visibility: hidden;
                display: flex;
                gap: 10px;
                align-items: flex-start;
                .text-status {
                  font-family: $font-inter-regular;
                  font-size: 18px;
                  line-height: 21px;
                  color: var(--text-off);
                  max-width: 245px;
                }
              }

              .group_btn-btn {
                .link {
                  display: block;
                  color: var(--dark-1);
                }
                .btn {
                  @include btn-common(no);
                  min-width: 140px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.status-mobile {
  display: none;
}
.link_account {
  font-size: $font-small;
  font-weight: 500;
  margin: 0px;
  margin-top: 6px;
  margin-bottom: 20px;
  color: $color-grey-dusty;
  line-height: 20px;
  display: block;
  a {
    color: $color-curious-blue;
    &:hover {
      text-decoration: none;
    }
  }
}
.link_button {
  color: $color-curious-blue;
}

.right_withdrawal_acc {
  display: block;
  width: calc(100% - 110px - 70px - 15px);
  position: relative;
  line-height: 20px;
  font-size: $font-small;
  color: $color-grey-dusty;
}
.switch {
  margin-bottom: 0px;
  input:checked + span {
    background-color: $color-jungle-green;
  }
  span {
    background-color: #d8d8d8;
  }
}
.icon_if_w {
  width: 18px;
  height: 18px;
  font-size: $font-big;
  color: $color-alizarin-crimson;
}
.btn_active {
  height: 35px;
  max-width: 100%;
  width: 246px;
  margin-right: 15px;
  text-align: center;
  background-color: $color-jungle-green;
  border-radius: 3px;
  font-weight: 600;
  color: $color-white;
  font-size: $font-smaller;
  text-transform: uppercase;
  display: inline-block;
  padding: 8px 0px;
  line-height: 20px;
  overflow: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  &:hover,
  &:active,
  &:focus {
    background-color: $color-blue-custom;
    border-color: $color-blue-custom;
    outline: none;
  }
}
.step_active {
  color: $color-corn-pale;
  &:after {
    background: $color-corn-pale;
    content: "";
    display: block;
    width: 100%;
    height: 4px;
    position: absolute;
    left: 0px;
    bottom: -3px;
  }
}
.no-shadow {
  i {
    box-shadow: none !important;
  }
}
.link_referral {
  a {
    text-decoration: none !important;
  }
}
.mgb0 {
  margin-bottom: 0px;
}
@media screen and (max-width: 1600px) {
  .right_list_option_acc {
    .contents_setting {
      padding: 36px 43px;
    }
  }
}

@media screen and (max-width: 992px) {
  .title-medium-small {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 30px;
  }
  .right_list_option_acc {
    .contents_setting {
      padding: 36px 15px;
      .contents_setting_container {
        gap: 10px;
        margin-bottom: 20px;
        .text-main {
          font-size: 14px;
          line-height: 16px;
        }
        .contents_setting_icon {
          width: 41px;
          img {
            width: 41px;
            height: 40px;
          }
        }
        .preferences_group {
          .group {
            margin-bottom: 20px;
            .group_center_option {
              flex-direction: column;
              position: relative;

              .center_group {
                min-width: 217px;

                .link_lost_opt {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
              .center_group-whitelist,
              .center-group-anti {
                max-width: 222px;
              }

              .group_btn {
                &.flex_end {
                  justify-content: flex-start;
                }
                .group_status {
                  gap: 5px;
                  align-items: center;
                  position: absolute;
                  right: 0;
                  top: 0px;
                  img {
                    width: 16px;
                    height: 16px;
                  }
                  .text-status {
                    font-weight: 400;
                    font-size: 14px;
                  }
                }

                .group_btn-btn {
                  .btn {
                    min-width: 100px;
                    margin-top: 24px;
                    padding: 7.5px 10px;
                    font-size: 14px;
                    line-height: 16px;
                  }
                }
              }
            }
          }
          .check_authen_activation {
            font-size: 12px;
            line-height: 16px;
          }
          .address_management {
            .address_management-link {
              font-size: 12px;
              line-height: 16px;
            }
          }
        }
      }
    }
  }
  .status-mobile {
    display: block;
  }
}
</style>

<style lang="scss">
#account {
  #confirmationModal {
    .modal-body {
      padding: 0 50px 50px;
      button {
        min-width: auto;
      }
    }
  }
}
#account_secuity {
  #confirmationModal {
    .modal-body {
      .mart50 {
        padding-bottom: 0;
        button {
          min-width: unset;
        }
      }
    }
  }
  @media screen and (max-width: 992px) {
    #confirmationModal {
      .modal-dialog {
        .modal-content {
          width: 100% !important;

          .modal-body {
            padding: 0 15px 30px;
            .content_text {
              font-size: 16px;
              line-height: 19px;
            }

            .mart50 {
              button {
                font-size: 16px;
                line-height: 19px;
              }
            }
          }
        }
      }
      .icon {
        width: 80px;
      }
    }
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 576px) {
  }


  /* Security Level */
  .security-level-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    padding-bottom: 20px;
    overflow-x: auto;
    margin-bottom: 24px;
  }

  .security-card {
    flex: 1;
    min-width: 220px;
    background: $color-mirage;
    border: 1px solid $color-gun-powder;
    border-radius: 4px;
    padding: 16px;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.3s ease;
    
    &.clickable {
      cursor: pointer;
      
      &:hover {
        border-color: rgba($color-caribbean-green, 0.5);
        background: rgba($color-caribbean-green, 0.02);
      }
    }

    &.current {
      border: 1px solid $color-caribbean-green;
      background: rgba($color-caribbean-green, 0.05);
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: $color-caribbean-green;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }

    &.active .security-icon svg,
    &.current .security-icon svg,
    &.completed .security-icon svg {
      color: $pure_color_white;
    }
  }

  .security-card-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .security-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-storm-grey;
    
    svg {
       width: 32px;
       height: 32px;
    }
  }

  .security-icon text {
    fill: currentColor;
  }

  .security-info {
    display: flex;
    flex-direction: column;
  }

  .security-level-title {
    font-size: 14px;
    font-weight: 500;
    color: $pure_color_white;
    margin-bottom: 4px;
  }

  .security-level-desc {
    font-size: 12px;
    color: $color-santas-gray;
    line-height: 1.2;
  }

  @media (max-width: 992px) {
    .security-level-wrapper {
      flex-direction: column;
    }
    
    .security-card {
      width: 100%;
      margin-bottom: 12px;
    }
  }

  .light-theme & {
    .security-card {
      background: $color-white;
      border-color: $color-platinum;
      
      .security-level-title {
        color: $dark-1;
      }
      
      .security-level-desc {
        color: $dark-2;
      }

      &.current {
        background: rgba($color-caribbean-green, 0.08);
        border-color: $color-caribbean-green;
      }
      
      &.active .security-icon svg,
      &.current .security-icon svg,
      &.completed .security-icon svg {
         color: $color-caribbean-green; 
      }
    }
  }
}
</style>
